module.exports = __webpack_public_path__ + "assets/img/78.90615ba5.png";